import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FuseSharedModule } from '@fuse/shared.module';
import { FormsModule } from '@angular/forms';

import { FuseContentComponent } from 'app/main/content/content.component';

@NgModule({
    declarations: [
        FuseContentComponent
    ],
    imports     : [
        RouterModule,

        FuseSharedModule,
        FormsModule
    ],
    exports: [
        FuseContentComponent
    ]
})
export class FuseContentModule
{
}
